import { Box } from '@mui/material';
import { FunctionComponent, SVGProps } from 'react';
import { Typography } from '../../../../primitives/typography/typography';

type LoginIntroProps = {
  logo?: FunctionComponent<SVGProps<SVGSVGElement>>;
  message?: string;
};

export const LoginIntro = ({ logo: Logo, message }: LoginIntroProps) => {
  return (
    <>
      <Box sx={{ alignSelf: 'flex-start', pb: 2 }}>
        {Logo && (
          <Logo
            preserveAspectRatio="xMinYMin meet"
            style={{ display: 'block', width: 200, height: 'auto', maxHeight: 100 }}
          />
        )}
      </Box>
      {message && (
        <Typography.Heading sx={{ pb: 1, alignSelf: 'stretch' }}>{message}</Typography.Heading>
      )}
    </>
  );
};
